module.exports = __webpack_public_path__ + "img/eprf-users.d1758db0.png";